module.exports = __webpack_public_path__ + "img/case-study-MOD.7e74aabc.png";